import { render, staticRenderFns } from "./LimitedAccessDialog.vue?vue&type=template&id=bc736de8&"
import script from "./LimitedAccessDialog.vue?vue&type=script&lang=ts&"
export * from "./LimitedAccessDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports